/** The home welcome piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { HomeWelcomeEvents } from './contract';
import { HomeWelcomeView } from './HomeWelcomeView';
import { useHomeWelcome } from './useHomeWelcome';

export { HomeWelcomeView, useHomeWelcome };

export function HomeWelcome(props: PieceInput<HomeWelcomeEvents>) {
  return <HomeWelcomeView {...useHomeWelcome(props)} />;
}
